import { useMutation } from '@tanstack/react-query';
import { updateUser, userLogin } from '../../users';

import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

const useUpdateUser = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: handleUpdateUser, isPending } = useMutation({
		mutationFn: (data) => updateUser(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleUpdateUser, isPending };
};

export default useUpdateUser;
